import { useEffect, useRef, useState } from 'react';
import { Dimensions, Keyboard, Platform } from 'react-native';

const useKeyboardInfo = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const subscriptions = useRef([]),
    _keyboardHeight = useRef(0);
  const WINDOW_HEIGHT = Dimensions.get('window').height;

  function onKeyboardChange(keyboardEvent) {
    if (!keyboardEvent) {
      return _setKeyboardHeight(0);
    }
    // when keyboardEvent.endCoordinates.screenY is equal to window height,
    // this means that the keyboard is closed .
    const height =
      WINDOW_HEIGHT !== keyboardEvent.endCoordinates.screenY
        ? keyboardEvent.endCoordinates.height
        : 0;
    if (_keyboardHeight.current === height) {
      return;
    }
    _setKeyboardHeight(height);
  }
  function _setKeyboardHeight(height) {
    _keyboardHeight.current = height;
    setKeyboardHeight(height);
  }

  useEffect(() => {
    if (Platform.OS === 'ios') {
      subscriptions.current = [Keyboard.addListener('keyboardWillChangeFrame', onKeyboardChange)];
    } else {
      subscriptions.current = [
        Keyboard.addListener('keyboardDidHide', onKeyboardChange),
        Keyboard.addListener('keyboardDidShow', onKeyboardChange),
      ];
    }
    return () => {
      subscriptions.current.forEach(subscription => subscription.remove());
    };
  }, []);

  return { keyboardHeight };
};

export default useKeyboardInfo;
